package com.mshopsas.enterprise.aiw.scan.network

data class ApiError(val code:Int = -1,  val message: String? = null)